module.exports = __webpack_public_path__ + "site/img/whatsapp.92e9e639.png";